import React from "react";
import { View, Text, Image, TouchableOpacity } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppImages } from "../../../utility/AppImages";
import SvgImage from "../../../Components/choose-avatar-components/SvgImage";

const EventInfo = ({ onCloseClick }) => {
  const styles = useStyles();

  return (
    <View style={styles.mainView}>
      {/* Close button in top-right corner */}
      <TouchableOpacity style={styles.closeBtn} onPress={onCloseClick}>
        <Image source={AppImages.icClose} style={styles.closeIcon} />
      </TouchableOpacity>

      {/* Kall Out Event Section */}
      <View style={styles.eventItem}>
        <View style={{  marginRight: 12 }}>
          <SvgImage src={AppImages.icPublic} variant="eventCreateInfo" />
        </View>
        <View style={styles.eventTextWrapper}>
          <Text style={styles.eventTitle}>Kall Out Event:</Text>
          <Text style={styles.eventDescription}>
            Kall out players from anywhere in the world and let the audience
            watch as you battle for victory. Public, free, and for the bold.
          </Text>
        </View>
      </View>

      {/* Exclusive Event Section */}
      <View style={[styles.eventItem, { marginTop: 12 }]}>
       
        <View style={{ marginRight: 12 }}>
          <SvgImage src={AppImages.icPrivate} variant="eventCreateInfo" />
        </View>{" "}
        <View style={styles.eventTextWrapper}>
          <Text style={styles.eventTitle}>Exclusive Event:</Text>
          <Text style={styles.eventDescription}>
            Host private, ticketed events for your audience. Set the stakes,
            invite your community, and take centre stage in a premium
            experience.
          </Text>
        </View>
      </View>
    </View>
  );
};

export default EventInfo;

const useStyles = CreateResponsiveStyle(
  {
    mainView: {
      backgroundColor: AppColors.black_121212,
      borderRadius: 12,
      padding: 16,
      width: 315, // adjust as needed
    },
    closeBtn: {
      position: "absolute",
      top: 8,
      right: 8,
      zIndex: 10,
    },
    closeIcon: {
      width: 20,
      height: 20,
      tintColor: "#fff",
      resizeMode: "contain",
    },
    eventItem: {
      flexDirection: "row",
      borderRadius: 10,
    },
 
    eventTextWrapper: {
      flex: 1,
      flexDirection: "column",
    },
    eventTitle: {
      ...AppFontStyle.BOLD_ANYBODY_14,
      color: AppColors.white,
      marginBottom: 4,
    },
    eventDescription: {
      ...AppFontStyle.REGULAR_ANYBODY_12,
      color: AppColors.white,
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      mainView: {
        width: "100%",
      },
    },
    [DEVICE_SIZES.SM]: {
      mainView: {
        width: "100%",
      },
    },
  }
);
